import * as cx from "classnames/bind";
import { Button, Icon } from "components";
import { useCart } from "hooks";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import s from "styles/Cart.module.scss";

const OrderSummary = ({ className }) => {
  const { cart, removeCoupon, addCoupon } = useCart();
  const currency = cart.currency || "nok";
  const { t } = useTranslation();

  const [codeValue, setCodeValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isInvalidCode, setIsInvalidCode] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <div className={cx(s.cProductItem, s.cCouponHolder)}>
        {Object.entries(cart.coupons).length < 1 && (
          <>
            <a onClick={toggle}>
              {t("Do you have a discount code? Click here")}
            </a>
            <div className={cx(s.cCouponInput, isOpen ? s.active : null)}>
              <input
                value={codeValue}
                type="text"
                placeholder={t("Add discount code here")}
                onChange={(e) => {
                  setCodeValue(e.target.value);
                }}
              />
              <button
                onClick={async () => {
                  const newCart = await addCoupon(codeValue);
                  setIsInvalidCode(false);
                  if (newCart.coupons[codeValue]) {
                    setCodeValue("");
                    setIsOpen(false);
                  } else {
                    setIsInvalidCode(true);
                  }
                }}
              >
                {t("ADD")}
              </button>
            </div>
          </>
        )}
        <ul className={cx(s.cCouponResults)}>
          {Object.entries(cart.coupons).map((c) => {
            const [code, coupon] = c;
            return (
              <li key={coupon.id}>
                <Icon size="far" svg="badge-percent" />
                {t("Discount")}
                <span>{code}</span>
                <p>
                  {coupon.amount_off
                    ? `-${coupon.amount_off / 100} ${currency.toUpperCase()}`
                    : `${coupon.percentage_off || coupon.percent_off}%`}
                </p>
                <Button
                  size="fas"
                  svg="remove"
                  onClick={() => removeCoupon(code)}
                />
              </li>
            );
          })}
        </ul>
      </div>
      <div className={cx(s.cProductItem, s.cLineItem)}>
        <p>{t("Subtotal")}</p>
        <p className={cx(s.cPrice)}>
          {(cart.sub_total || 0) / 100}{" "}
          <span className="cur">{currency.toUpperCase()}</span>
        </p>
      </div>
      <div className={cx(s.cProductItem, s.cLineItem)}>
        <p>{t("Discount")}</p>
        <p className={cx(s.cPrice)}>
          {(cart.discount || 0) / 100}{" "}
          <span className="cur">{currency.toUpperCase()}</span>
        </p>
      </div>
      <div className={cx(s.cProductItem, s.cLineItem)}>
        <p>{t("Shipping")}</p>
        <p className={cx(s.cPrice)}>
          {(cart.shipping || 0) / 100}{" "}
          <span className="cur">{currency.toUpperCase()}</span>
        </p>
      </div>
      <div className={cx(s.cProductItem, s.cLineItem, s.cLineItemTotal)}>
        <p className="Bold">Total</p>
        <p className={cx(s.cPrice)}>
          {(cart.total || 0) / 100}{" "}
          <span className="cur">{currency.toUpperCase()}</span>
        </p>
      </div>
    </>
  );
};
export default OrderSummary;
